import { useQuery } from '@tanstack/react-query';

import { fetchMyIdentification } from '../api/fetchMyIdentification.js';
import { identificationKeys } from './keys.js';

export function myIdentificationQueryDefinition() {
  return {
    queryKey: identificationKeys.my(),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchMyIdentification(signal),
    staleTime: Infinity,
    meta: {
      toast: {
        title: 'Could not load user identification',
        description: 'User identification could not be fetched.',
      },
    },
  } as const;
}

export function useMyIdentificationQuery() {
  return useQuery(myIdentificationQueryDefinition());
}
